import { NavLink } from 'react-router-dom';
import { Icon } from '../../../icon/Icon';
import { Tooltip } from '../../../tooltip/Tooltip';
import { TabProps } from './models';
import { SecondarySidebarItemTooltip } from './SecondarySidebarItemTooltip';

export function SecondarySidebarItem<T>({
  tab,
  expanded
}: {
  tab: TabProps<T>;
  expanded: boolean;
}) {
  return (
    <Tooltip
      dataId={tab.label}
      title={<SecondarySidebarItemTooltip showLabel={!expanded} label={tab.label} />}
      disabled={expanded}
      mode='surface'
      placement='right'
    >
      <NavLink to={tab.path} className='tab-nav-link'>
        <Icon name={tab.icon} className='tab-nav-link-icon' />
        {expanded ? <span className='tab-nav-link-text'>{tab.label}</span> : null}
      </NavLink>
    </Tooltip>
  );
}
